var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return !_vm.getAnswered
    ? _c("g-g-app-modal", {
        attrs: {
          "is-active": _vm.modelValue,
          width: "600px",
          persistent: true,
          "close-button-positions": ["header"],
          "footer-close-attrs": {
            color: "primary",
            text: true
          }
        },
        on: {
          close: _vm.close
        },
        scopedSlots: _vm._u(
          [
            {
              key: "header",
              fn: function fn() {
                return [
                  _vm.step != 0
                    ? _c(
                        "div",
                        {
                          staticClass: "mr-auto ml-auto",
                          staticStyle: {
                            "text-align": "start"
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.getSurvey.title) + " ")]
                      )
                    : _vm._e()
                ]
              },
              proxy: true
            },
            {
              key: "body",
              fn: function fn() {
                return [
                  _c(
                    "app-survey-stepper",
                    {
                      attrs: {
                        steps: _vm.stepsCount,
                        "hide-controls-for-steps": [0],
                        loading: _vm.isSending
                      },
                      on: {
                        change: function change(newStep) {
                          _vm.step = newStep
                        },
                        finish: _vm.sendSurvey
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "controls",
                            fn: function fn(_ref) {
                              var nextStep = _ref.nextStep,
                                previousStep = _ref.previousStep,
                                isFirstStep = _ref.isFirstStep,
                                isLastStep = _ref.isLastStep,
                                hideControlsForSteps =
                                  _ref.hideControlsForSteps,
                                steps = _ref.steps
                              return [
                                _c(
                                  "gg-btn",
                                  {
                                    attrs: {
                                      text: "",
                                      disabled: isFirstStep || _vm.isSending
                                    },
                                    on: {
                                      click: previousStep
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          left: "",
                                          small: ""
                                        }
                                      },
                                      [_vm._v("mdi-chevron-left")]
                                    ),
                                    _vm._v(" Back ")
                                  ],
                                  1
                                ),
                                _c("span", [
                                  _vm._v(
                                    " Step " +
                                      _vm._s(
                                        _vm.step +
                                          1 -
                                          hideControlsForSteps.length
                                      ) +
                                      " of " +
                                      _vm._s(
                                        steps - hideControlsForSteps.length
                                      ) +
                                      " "
                                  )
                                ]),
                                _c(
                                  "gg-btn",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !isLastStep,
                                        expression: "!isLastStep"
                                      }
                                    ],
                                    attrs: {
                                      text: "",
                                      disabled: _vm.isSending
                                    },
                                    on: {
                                      click: function click($event) {
                                        return _vm.validateBeforeNextStep(
                                          nextStep
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(" Next "),
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          right: "",
                                          small: ""
                                        }
                                      },
                                      [_vm._v("mdi-chevron-right")]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "gg-btn",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: isLastStep,
                                        expression: "isLastStep"
                                      }
                                    ],
                                    attrs: {
                                      loading: _vm.isSending
                                    },
                                    on: {
                                      click: _vm.sendSurvey
                                    }
                                  },
                                  [_vm._v(" Finish ")]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1346576309
                      ),
                      model: {
                        value: _vm.step,
                        callback: function callback($$v) {
                          _vm.step = $$v
                        },
                        expression: "step"
                      }
                    },
                    [
                      [
                        _c(
                          "app-survey-step",
                          {
                            staticClass:
                              "pt-5 d-flex flex-column align-items-center",
                            attrs: {
                              step: 0
                            }
                          },
                          [
                            _c("welcoming-step", {
                              attrs: {
                                title: _vm.getSurvey.title || "",
                                description: _vm.getSurvey.description || ""
                              },
                              on: {
                                start: function start($event) {
                                  _vm.step = 1
                                },
                                skip: _vm.close
                              }
                            })
                          ],
                          1
                        ),
                        _vm._l(_vm.getSurvey.questions, function(item, key) {
                          return _c(
                            "app-survey-step",
                            {
                              key: "step-".concat(key),
                              staticClass:
                                "py-6 d-flex flex-column align-items-center",
                              attrs: {
                                step: key + 1
                              }
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticStyle: {
                                    width: "100%"
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "h4 mb-4 font-weight-bold"
                                        },
                                        [_vm._v(_vm._s(item.prompt))]
                                      )
                                    ]
                                  ),
                                  item.type === "select"
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: {
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c("gg-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            key: "select-".concat(key),
                                            attrs: {
                                              outlined: "",
                                              placeholder: "Select an option",
                                              "item-value": "id",
                                              "item-text": "label",
                                              items: item.options,
                                              "data-vv-name": "select-".concat(
                                                item.id
                                              ),
                                              "error-messages": _vm.errors.collect(
                                                "select-".concat(item.id)
                                              ),
                                              "data-vv-as": "Field",
                                              disabled: _vm.isSending
                                            },
                                            model: {
                                              value: _vm.data.selected[item.id],
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.data.selected,
                                                  item.id,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "data.selected[item.id]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : item.type === "select" &&
                                      item.options.find(function(i) {
                                        return (
                                          i.id == _vm.data.selected[item.id]
                                        )
                                      }) &&
                                      item.options.find(function(i) {
                                        return (
                                          i.id == _vm.data.selected[item.id]
                                        )
                                      }).label === "Other"
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: {
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c("gg-text-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            key: "text-".concat(key),
                                            attrs: {
                                              label: "In more detail",
                                              outlined: "",
                                              "data-vv-name": "text-".concat(
                                                item.id
                                              ),
                                              "data-vv-as":
                                                "Field for Other option",
                                              "error-messages": _vm.errors.collect(
                                                "text-".concat(item.id)
                                              ),
                                              disabled: _vm.isSending
                                            },
                                            model: {
                                              value: _vm.data.text[item.id],
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.data.text,
                                                  item.id,
                                                  $$v
                                                )
                                              },
                                              expression: "data.text[item.id]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : item.type === "select-multi"
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: {
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c("gg-select", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            key: "multi-".concat(key),
                                            ref: "multi-".concat(key),
                                            refInFor: true,
                                            attrs: {
                                              outlined: "",
                                              multiple: "",
                                              placeholder:
                                                "Select one or more options",
                                              "item-value": "id",
                                              "item-text": "label",
                                              items: item.options,
                                              "data-vv-name": "select-".concat(
                                                item.id
                                              ),
                                              "data-vv-as": "Field",
                                              "error-messages": _vm.errors.collect(
                                                "select-".concat(item.id)
                                              ),
                                              disabled: _vm.isSending,
                                              "menu-props": _vm.menuPropsFor(
                                                key
                                              )
                                            },
                                            on: {
                                              focus: function focus($event) {
                                                return _vm.syncSelectMenuWidth(
                                                  key
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.data.selected[item.id],
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.data.selected,
                                                  item.id,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "data.selected[item.id]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : item.type === "select-multi" &&
                                      _vm.data.selected &&
                                      _vm.data.selected[item.id] &&
                                      _vm.data.selected[item.id].length &&
                                      item.options.find(function(i) {
                                        return i.label == "Other"
                                      }) &&
                                      _vm.data.selected[item.id].includes(
                                        item.options.find(function(i) {
                                          return i.label == "Other"
                                        }).id
                                      )
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: {
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c("gg-text-field", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            key: "text-".concat(key),
                                            attrs: {
                                              label:
                                                "Since you selected Other, enter your own response:",
                                              outlined: "",
                                              placeholder:
                                                "Enter something not on our list",
                                              "data-vv-name": "text-".concat(
                                                item.id
                                              ),
                                              "data-vv-as":
                                                "Field for Other option",
                                              "error-messages": _vm.errors.collect(
                                                "text-".concat(item.id)
                                              ),
                                              disabled: _vm.isSending
                                            },
                                            model: {
                                              value: _vm.data.text[item.id],
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.data.text,
                                                  item.id,
                                                  $$v
                                                )
                                              },
                                              expression: "data.text[item.id]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : item.type === "text"
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: {
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c("v-textarea", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            key: "textarea-".concat(key),
                                            staticClass: "gg-input",
                                            attrs: {
                                              outlined: "",
                                              dense: "",
                                              "data-vv-name": "field-".concat(
                                                item.id
                                              ),
                                              "data-vv-as": "Field",
                                              "error-messages": _vm.errors.collect(
                                                "field-".concat(item.id)
                                              ),
                                              disabled: _vm.isSending
                                            },
                                            model: {
                                              value: _vm.data.text[item.id],
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.data.text,
                                                  item.id,
                                                  $$v
                                                )
                                              },
                                              expression: "data.text[item.id]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : item.type === "select-radio"
                                    ? _c(
                                        "v-col",
                                        [
                                          _c(
                                            "v-radio-group",
                                            {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                }
                                              ],
                                              key: "radio-".concat(key),
                                              staticClass: "mt-0",
                                              attrs: {
                                                row: false,
                                                "data-vv-name": "radio-".concat(
                                                  item.id
                                                ),
                                                "data-vv-as": "Field",
                                                "error-messages": _vm.errors.collect(
                                                  "radio-".concat(item.id)
                                                ),
                                                disabled: _vm.isSending,
                                                "hide-details": "auto"
                                              },
                                              model: {
                                                value:
                                                  _vm.data.selected[item.id],
                                                callback: function callback(
                                                  $$v
                                                ) {
                                                  _vm.$set(
                                                    _vm.data.selected,
                                                    item.id,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "data.selected[item.id]"
                                              }
                                            },
                                            _vm._l(item.options, function(
                                              option
                                            ) {
                                              return _c("v-radio", {
                                                key: option.id,
                                                staticClass: "mt-0",
                                                attrs: {
                                                  value: option.id
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "label",
                                                      fn: function fn() {
                                                        return [
                                                          _c("b", [
                                                            _vm._v(
                                                              _vm._s(
                                                                option.label
                                                              )
                                                            )
                                                          ]),
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    option.description,
                                                                  expression:
                                                                    "option.description"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "text-grey ml-2"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  option.description
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      },
                                                      proxy: true
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              })
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : item.type === "select-iconboxes" ||
                                      item.type === "select-iconboxes-multi"
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "pt-0"
                                        },
                                        [
                                          _c("g-g-buttons-list-group", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            key: "iconboxes-".concat(key),
                                            attrs: {
                                              "item-value-key": "id",
                                              "data-vv-name": "iconboxes-".concat(
                                                item.id
                                              ),
                                              "data-vv-as": "Field",
                                              "error-messages": _vm.errors.collect(
                                                "iconboxes-".concat(item.id)
                                              ),
                                              multi:
                                                item.type ===
                                                "select-iconboxes-multi"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function fn(_ref2) {
                                                    var isActive =
                                                        _ref2.isActive,
                                                      handleClick =
                                                        _ref2.handleClick
                                                    return [
                                                      item.size === "large"
                                                        ? _vm._l(
                                                            item.options,
                                                            function(option) {
                                                              return _c(
                                                                "g-g-card-btn",
                                                                {
                                                                  key: "iconbox-".concat(
                                                                    option.id
                                                                  ),
                                                                  class: {
                                                                    active: isActive(
                                                                      option.id
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.isSending,
                                                                    icon: option.icon
                                                                      ? "mdi-".concat(
                                                                          option.icon
                                                                        )
                                                                      : "mdi-star",
                                                                    label:
                                                                      option.label,
                                                                    description:
                                                                      option.description
                                                                  },
                                                                  on: {
                                                                    click: function click(
                                                                      $event
                                                                    ) {
                                                                      return handleClick(
                                                                        option.id
                                                                      )
                                                                    }
                                                                  }
                                                                }
                                                              )
                                                            }
                                                          )
                                                        : _vm._l(
                                                            item.options,
                                                            function(option) {
                                                              return _c(
                                                                "gg-btn",
                                                                {
                                                                  key: "iconbox-".concat(
                                                                    option.id
                                                                  ),
                                                                  attrs: {
                                                                    secondary: !isActive(
                                                                      option.id
                                                                    ),
                                                                    disabled:
                                                                      _vm.isSending
                                                                  },
                                                                  on: {
                                                                    click: function click(
                                                                      $event
                                                                    ) {
                                                                      return handleClick(
                                                                        option.id
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value:
                                                                            option.icon,
                                                                          expression:
                                                                            "option.icon"
                                                                        }
                                                                      ],
                                                                      staticClass:
                                                                        "mr-2",
                                                                      attrs: {
                                                                        left:
                                                                          "",
                                                                        size:
                                                                          "1.2rem"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            option.icon
                                                                              ? "mdi-".concat(
                                                                                  option.icon
                                                                                )
                                                                              : ""
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        option.label
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: _vm.data.selected[item.id],
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.data.selected,
                                                  item.id,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "data.selected[item.id]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ]
                    ],
                    2
                  )
                ]
              },
              proxy: true
            }
          ],
          null,
          false,
          992689513
        )
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }